/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import JsonQuery from 'json-query';
import { hooks as commonHooks, types as commonTypes } from '@sitebuilder/common';

const CHILDREN_PLACEHOLDER_ID = 'children';

export interface WidgetProperties extends commonTypes.WidgetPropertiesBase {
    dataKey: string;
}

const RepeaterWidget = (props: commonTypes.WidgetInstanceProps): JSX.Element => {
    const widgetProperties = commonHooks.useWidgetProperties<WidgetProperties>(
        props.widgetInstanceId
    );
    const widgetInstance = commonHooks.useWidgetInstance(props.widgetInstanceId);
    const { styles, dataKey } = widgetProperties || props;
    const { data } = props;
    const { Placeholder } = commonHooks.useAppContext();

    const repeaterData = JsonQuery(dataKey, { data }).value;

    return (
        <div
            css={css`
                ${styles}
            `}
        >
            {!dataKey ? (
                <Placeholder
                    contentPlaceHolderId={CHILDREN_PLACEHOLDER_ID}
                    parentWidgetInstanceId={widgetInstance?.id}
                    data={data}
                />
            ) : (
                Array.isArray(repeaterData) &&
                repeaterData?.map((item: any) => (
                    <Placeholder
                        key={item}
                        contentPlaceHolderId={CHILDREN_PLACEHOLDER_ID}
                        parentWidgetInstanceId={widgetInstance?.id}
                        data={{ ...data, ...repeaterData, currentRepeaterItem: item }}
                    />
                ))
            )}
        </div>
    );
};

export default RepeaterWidget;
